<template>
  <fin-percentage-change v-if="!isNaN(value) && Number.isFinite(value)" :change="value" v-bind="header.componentProps"/>
  <span v-else>-</span>
</template>

<script>
import FinPercentageChange from "@/components/common/PercentageChange/index"

export default {
  name: "PercentageChangeCell",
  components: {FinPercentageChange},
  props: {
    value: {},
    header: {}
  }
}
</script>

<style scoped>

</style>
